<template>
  <div class="side-container">
    <h2 class="title">学科导航</h2>
    <!-- @scroll.passive="getScroll($event)" -->
    <ul
      class="side-content"
      v-if="classOneList.length > 0"
      @scroll.passive="getScroll($event)"
      
    >
      <li
        v-for="item in classOneList"
        :key="item.id"
        class="side-li"
      >
        <div class="left" @mouseenter="handleEnter(item)">
          <span class="content">{{ item.classifyName }}</span>
          <!-- <span class="icon" v-if="otherList.length > 0">&gt;</span> -->
        </div>
        <div
          class="right"
          v-if="otherList.length > 0"
          ref="test"
          :style="{ marginTop: -44 - topSize + 'px'}"
        >
          <span
            v-for="(v, i) in otherList"
            :key="v.id"
            @click="subClick(v, i, item)"
            :class="{ active: index === i }"
            >{{ v.classifyName }}</span
          >
          <Spin size="large" fix v-if="spinShow"></Spin>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spinShow: false,
      otherList: [],
      classOneList: [],
      topSize: 0,
      index: -1,
      choose: {},
      chooseItem: "",
      chooseIndex: "",
      lastId:-1
    };
  },
  created() {
    this.classificationOneList();
  },
  methods: {
    getScroll(event) {
        this.topSize = 0;
        this.topSize = this.topSize + event.target.scrollTop;
    },
    subClick(v, i, item) {
      this.chooseIndex = i;
      this.chooseItem = item;
      if (v.classifyName === this.choose.classifyName) {
        this.index = -1;
        this.choose = {};
        this.chooseIndex = -1;
        this.$emit("requestAll", v);
      } else {
        this.index = i;
        this.choose = v;
        this.$emit("subClick", v, item);
      }
    },
    async classificationListByPid(id) {
      const resp = await this.$apis.mainServe.classificationListByPid({
        pid: id,
      });
      this.otherList = resp.content.classOtherList;
      this.spinShow = false
    },
    handleEnter(item) {
      if (this.chooseItem.id === item.id) {
        this.index = this.chooseIndex;
      } else {
        this.index = -1;
      }
      this.spinShow = true
      this.$preventFun.Debounce(() => {this.classificationListByPid(item.id)})()
    },
    // 分类
    async classificationOneList() {
      const resp = await this.$apis.mainServe.classificationOneList();
      this.classOneList = resp.classOneList;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-spin-main {
  top: 50% !important;
}
.side-content::-webkit-scrollbar {
  width: 6px;
}
.side-content::-webkit-scrollbar-thumb {
  width: 6px;
  // border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px #A3CBE7;
  background: #A3CBE7;
}
.side-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #fff;
  border-radius: 0;
  // background: rgba(0, 0, 0, 0.1);
}
.side-container {
  box-sizing: border-box;
  display: inline-block;
  margin-bottom: 9px;
  padding-bottom: 38px;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  .title {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    margin: 27px 0px 0 30px;
  }
  .side-content {
    box-sizing: border-box;
    margin-top: 12px;
    height: 440px;
    overflow-y: scroll;
    .side-li {
      padding-left: 4px;
      height: 44px;
      line-height: 44px;
      cursor: pointer;
      .right {
        display: none;
        flex-wrap: wrap;
        position: absolute;
        margin: -44px 0 0 295px;
        width: 900px;
        padding: 40px;
        background-color: #ffffff;
        border: 1px solid #A3CBE7;
        border-radius: 0px 10px 10px 10px;
        z-index: 9;
        span {
          padding-right: 30px;
          width: 200px;
          font-size: 14px;
          color: #333333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &.active {
            font-weight: bold;
            color: #3A7AED;
          }
          &:not(:last-child) {
            &::after {
              display: inline-block;
            }
          }
        }
        // li {
        //   display: inline-block;
        // }
        &::after {
          content: "";
          display: block;
          position: absolute;
          left: -15px;
          top: -1px;
          width: 15px;
          height: 44px;
          background-color: #3A7AED;
          border-right: 1px solid #A3CBE7;
        }
      }
      &:hover {
        background: #3A7AED;
        color: #fff;
        .right {
          display: flex;
        }
      }
      .left {
        height: 100%;
        margin-left: 30px;
        border-bottom: none;
      }
      // &:not(:last-child) {
      //   .left {
      //     border-bottom: 1px dashed #b5b5b5;
      //   }
      // }
      .content {
        display: inline-block;
        width: 150px;
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        margin-right: 60px;
        color: inherit;
      }
      // .icon {
      //   opacity: 0.26;
      // }
    }
    .last {
      height: 44px;
      line-height: 44px;
      cursor: pointer;
      margin: 0 30px;
      border-bottom: none;
    }
  }
}
</style>
